/* tps-home-rows · R5 home rails, Option B "Mini chooser" + A's end card (founder pick 19 Oct; spec
   ~/Downloads/tps-v6-port/design/home-rail-motion-2026-10/REPORT.md). One deferred script for every rail, no library.
   Paging: one full view per press, card aligned, expo-out glide (520 ms) on scrollLeft with snap off; wheel / touch / pointer
   cancels. Fades + Previous / Next state on scroll (rAF) and resize. Chips swap the cards from <template>s in place.
   Reduced motion: instant jump + a short opacity dip; chip swap is a crossfade. Mouse drag on desktop; Back keeps each row. */
(function () {
  var rails = document.querySelectorAll('[data-hr]');
  if (!rails.length) return;
  var RM = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var ease = function (t) { return t >= 1 ? 1 : 1 - Math.pow(2, -10 * t); };

  function wire(rail) {
    var track = rail.querySelector('.tps-hr__s'), nav = rail.querySelector('.tps-hr__nav');
    if (!track || track.__hr) return;
    track.__hr = 1;
    var btns = rail.querySelectorAll('[data-hr-go]'), raf = 0, anim = 0;
    var kids = track.children;
    function step() { return kids.length > 1 ? kids[1].offsetLeft - kids[0].offsetLeft : 1; }
    function perView() { var cs = getComputedStyle(track); return Math.max(1, Math.floor((track.clientWidth - 2 * parseFloat(cs.paddingLeft) + (parseFloat(cs.columnGap) || 0) + 2) / step())); }
    function max() { return track.scrollWidth - track.clientWidth; }
    var last = '';
    function state() {
      raf = 0;
      var x = track.scrollLeft, m = max(), hp = x > 2, hn = x < m - 2, key = (hp ? 1 : 0) + '' + (hn ? 1 : 0) + (m <= 2 ? 1 : 0);
      if (key === last) return;   /* write only on a change: no style work on every glide frame */
      last = key;
      rail.classList.toggle('has-prev', hp); rail.classList.toggle('has-next', hn);
      btns.forEach(function (b) { b.setAttribute('aria-disabled', String(+b.getAttribute('data-hr-go') < 0 ? !hp : !hn)); });
      if (nav) nav.classList.toggle('is-idle', m <= 2);
    }
    function queue() { if (!raf) raf = requestAnimationFrame(state); }
    track.addEventListener('scroll', queue, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(queue).observe(track); else addEventListener('resize', queue);
    function cancel() { if (anim) { cancelAnimationFrame(anim); anim = 0; track.style.scrollSnapType = ''; } }
    ['wheel', 'touchstart', 'pointerdown'].forEach(function (ev) { track.addEventListener(ev, cancel, { passive: true }); });
    function go(dir) {
      var s = step(), n = perView(), m = max(), from = track.scrollLeft;
      var to = Math.max(0, Math.min(m, (Math.round(from / s) + dir * n) * s));
      if (Math.abs(to - from) < 1) return;
      cancel();
      if (RM.matches) {
        track.style.scrollSnapType = 'none'; track.scrollLeft = to; track.style.scrollSnapType = '';
        track.classList.remove('rm-dip'); void track.offsetWidth; track.classList.add('rm-dip'); return;
      }
      var t0 = performance.now();
      track.style.scrollSnapType = 'none';
      (function frame(now) {
        var p = Math.min(1, (now - t0) / 520);
        track.scrollLeft = from + (to - from) * ease(p);
        if (p < 1) anim = requestAnimationFrame(frame); else { anim = 0; track.style.scrollSnapType = ''; }
      })(t0);
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { if (b.getAttribute('aria-disabled') !== 'true') go(+b.getAttribute('data-hr-go')); }); });
    track.addEventListener('keydown', function (e) {
      if (e.target !== track) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    });

    /* chips: swap the cards in place; the Shop all link, its count and noun and the end card follow the chip */
    var chips = rail.querySelectorAll('.tps-hr__chip'), live = rail.querySelector('[data-hr-live] span'), link = rail.querySelector('[data-hr-link]');
    if (chips.length) {
      var groups = { all: track.innerHTML }, swapT = 0;
      rail.querySelectorAll('template[data-hr-tpl]').forEach(function (t) { groups[t.getAttribute('data-hr-tpl')] = t.innerHTML; });
      chips.forEach(function (ch) {
        ch.addEventListener('click', function () {
          if (ch.getAttribute('aria-pressed') === 'true') return;
          var g = ch.getAttribute('data-hr-g'); if (groups[g] == null) return;
          chips.forEach(function (o) { o.setAttribute('aria-pressed', String(o === ch)); });
          if (link) {
            link.setAttribute('href', ch.getAttribute('data-href'));
            var nn = link.querySelector('[data-hr-n]'), ww = link.querySelector('[data-hr-w]');
            if (nn) nn.textContent = ch.getAttribute('data-n'); if (ww) ww.textContent = ch.getAttribute('data-w');
          }
          if (live) live.textContent = 'Showing ' + ch.getAttribute('data-n') + ' ' + ch.getAttribute('data-w');
          cancel(); clearTimeout(swapT);
          var rm = RM.matches;
          function swap() {
            track.classList.remove('is-out');
            track.style.scrollSnapType = 'none'; track.innerHTML = groups[g]; track.scrollLeft = 0; track.style.scrollSnapType = '';
            var n = perView();
            if (track.animate) for (var i = 0; i < kids.length && i < n + 1; i++) {
              kids[i].animate(rm ? [{ opacity: 0 }, { opacity: 1 }] : [{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }],
                { duration: rm ? 160 : 280, delay: rm ? 0 : i * 30, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'backwards' });
            }
            last = ''; state();
          }
          if (rm) swap(); else { track.classList.add('is-out'); swapT = setTimeout(swap, 120); }
        });
      });
    }

    /* mouse drag on desktop (touch and trackpads scroll natively) */
    var x0 = 0, l0 = 0, down = false, moved = false;
    track.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.button !== 0) return; down = true; moved = false; x0 = e.clientX; l0 = track.scrollLeft; });
    addEventListener('pointermove', function (e) { if (!down) return; var d = e.clientX - x0; if (Math.abs(d) > 4) { moved = true; track.classList.add('is-drag'); } if (moved) track.scrollLeft = l0 - d; });
    addEventListener('pointerup', function () { if (!down) return; down = false; setTimeout(function () { track.classList.remove('is-drag'); }, 0); });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    state();
  }
  rails.forEach(wire);

  /* Back keeps each row where it was (Hermes H-HR-02) */
  var KEY = 'tps-hr-x', tracks = document.querySelectorAll('[data-hr] .tps-hr__s');
  try {
    var nv = performance.getEntriesByType('navigation')[0];
    if (nv && nv.type === 'back_forward') {
      var xs = JSON.parse(sessionStorage.getItem(KEY) || '[]');
      tracks.forEach(function (s, i) { if (xs[i] > 0) { s.style.scrollSnapType = 'none'; s.scrollLeft = xs[i]; requestAnimationFrame(function () { s.style.scrollSnapType = ''; }); } });
    }
  } catch (e) {}
  addEventListener('pagehide', function () { try { sessionStorage.setItem(KEY, JSON.stringify([].map.call(tracks, function (s) { return Math.round(s.scrollLeft); }))); } catch (e) {} });
})();
